<template>
  <div>
    <!-- 明細項目数の表示とTSVダウンロードボタン -->
    <div class="mb-5 flex align-center gap-3">
      <el-button
        type="normal"
        size="small"
        icon="el-icon-download"
        @click="handleDownloadTsv"
        :disabled="
          viewMode === 'filtered'
            ? filteredDetailComparisonData3.length === 0
            : allItemsComparison.length === 0
        "
      >
        TSVダウンロード
      </el-button>
      <div class="text-14 text-gray-800 ml-2">
        <span>明細項目総数: </span>
        <span class="text-bold">{{ doc1Label }}:</span> {{ doc1Items.length }}件
        <span class="ml-4 text-bold">{{ doc2Label }}:</span> {{ doc2Items.length }}件
      </div>
    </div>

    <!-- 明細項目（グループ表示） -->
    <!-- 表示モード切り替え -->
    <div class="view-mode-selection mb-3">
      <el-button
        :type="viewMode === 'filtered' ? 'primary' : 'text'"
        size="small"
        @click="viewMode = 'filtered'"
      >
        キーを選択して比較
      </el-button>
      <el-button
        :type="viewMode === 'all' ? 'primary' : 'text'"
        size="small"
        @click="viewMode = 'all'"
      >
        すべて
      </el-button>
    </div>

    <!-- すべての明細項目表示（比較表示） -->
    <div v-if="viewMode === 'all'" class="all-items-view">
      <div class="mb-2 text-14 text-gray-600">
        表示件数: {{ allItemsComparison.length }}件
      </div>
      <el-table
        :data="allItemsComparison"
        border
        stripe
        size="small"
        style="width: 100%"
        max-height="450"
      >
        <!-- 明細No -->
        <el-table-column
          prop="lineNo"
          label="明細No"
          width="80"
          align="center"
          fixed="left"
        >
          <template slot-scope="{ row }">
            <span :class="{ 'text-bold text-error': row.judgment === 'NG' }">
              {{ row.lineNo }}
            </span>
          </template>
        </el-table-column>

        <!-- 書類1グループ -->
        <el-table-column :label="doc1Label" align="center">
          <el-table-column
            prop="doc1_goodsShortName"
            label="商品名"
            width="150"
            align="left"
          >
            <template slot-scope="{ row }">
              <span
                :class="{ 'text-bold text-error': row.judgment === 'NG' }"
                style="white-space: normal; word-break: break-word; display: block;"
              >
                {{ row.doc1_goodsShortName }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="doc1_goodsRefNo1"
            label="商品番号"
            width="120"
            align="left"
            show-overflow-tooltip
          >
            <template slot-scope="{ row }">
              <span :class="{ 'text-bold text-error': row.judgment === 'NG' }">
                {{ row.doc1_goodsRefNo1 }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="doc1_quantity1"
            label="数量"
            width="100"
            align="right"
          >
            <template slot-scope="{ row }">
              <span :class="{ 'text-bold text-error': row.judgment === 'NG' }">
                {{ row.doc1_quantity1 }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="doc1_unitPrice"
            label="単価"
            width="100"
            align="right"
          >
            <template slot-scope="{ row }">
              <span :class="{ 'text-bold text-error': row.judgment === 'NG' }">
                {{ row.doc1_unitPrice }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="doc1_amount"
            label="金額"
            width="120"
            align="right"
          >
            <template slot-scope="{ row }">
              <span :class="{ 'text-bold text-error': row.judgment === 'NG' }">
                {{ row.doc1_amount }}
              </span>
            </template>
          </el-table-column>
        </el-table-column>

        <!-- 書類2グループ -->
        <el-table-column :label="doc2Label" align="center">
          <el-table-column
            prop="doc2_goodsShortName"
            label="商品名"
            width="150"
            align="left"
          >
            <template slot-scope="{ row }">
              <span
                :class="{ 'text-bold text-error': row.judgment === 'NG' }"
                style="white-space: normal; word-break: break-word; display: block;"
              >
                {{ row.doc2_goodsShortName }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="doc2_goodsRefNo1"
            label="商品番号"
            width="120"
            align="left"
            show-overflow-tooltip
          >
            <template slot-scope="{ row }">
              <span :class="{ 'text-bold text-error': row.judgment === 'NG' }">
                {{ row.doc2_goodsRefNo1 }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="doc2_quantity1"
            label="数量"
            width="100"
            align="right"
          >
            <template slot-scope="{ row }">
              <span :class="{ 'text-bold text-error': row.judgment === 'NG' }">
                {{ row.doc2_quantity1 }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="doc2_unitPrice"
            label="単価"
            width="100"
            align="right"
          >
            <template slot-scope="{ row }">
              <span :class="{ 'text-bold text-error': row.judgment === 'NG' }">
                {{ row.doc2_unitPrice }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="doc2_amount"
            label="金額"
            width="120"
            align="right"
          >
            <template slot-scope="{ row }">
              <span :class="{ 'text-bold text-error': row.judgment === 'NG' }">
                {{ row.doc2_amount }}
              </span>
            </template>
          </el-table-column>
        </el-table-column>

        <!-- 判定 -->
        <el-table-column
          prop="judgment"
          label="判定"
          width="80"
          align="center"
        >
          <template slot-scope="{ row }">
            <el-tag
              :type="row.judgment === 'OK' ? 'success' : 'danger'"
              size="small"
            >
              {{ row.judgment }}
            </el-tag>
          </template>
        </el-table-column>

        <!-- 差分 -->
        <el-table-column
          prop="differences"
          label="差分"
          min-width="250"
          align="left"
        >
          <template slot-scope="{ row }">
            <span
              :class="{ 'text-bold text-error': row.differences !== '-', 'text-gray-600': row.differences === '-' }"
              style="white-space: normal; word-break: break-word;"
            >
              {{ row.differences }}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 絞り込み表示（既存の比較結果） -->
    <div v-else>
      <!-- キー選択ボタン -->
      <div class="key-selection mb-3">
      <span class="text-14 text-gray-700 mr-2 text-bold">比較キー:</span>
      <el-button-group>
        <el-button
          :type="keyType === 'goodsShortName' ? 'primary' : 'default'"
          size="small"
          @click="handleKeyTypeChange('goodsShortName')"
        >
          商品名
        </el-button>
        <el-button
          :type="keyType === 'goodsRefNo1' ? 'primary' : 'default'"
          size="small"
          @click="handleKeyTypeChange('goodsRefNo1')"
        >
          商品番号
        </el-button>
        <el-button
          :type="keyType === 'both' ? 'primary' : 'default'"
          size="small"
          @click="handleKeyTypeChange('both')"
        >
          商品名・商品番号
        </el-button>
      </el-button-group>
    </div>

    <!-- 状態フィルター -->
    <div class="filter-buttons mb-3">
      <span class="text-14 text-gray-700 mr-2 text-bold">状態:</span>
      <el-radio-group v-model="statusFilter" size="small">
        <el-radio-button label="match">一致</el-radio-button>
        <el-radio-button label="doc1Only">{{ doc1Label }}のみ</el-radio-button>
        <el-radio-button label="doc2Only">{{ doc2Label }}のみ</el-radio-button>
        <el-radio-button label="duplicate">
          複数一致（重複）
        </el-radio-button>
      </el-radio-group>
          <span class="ml-3 text-14 text-gray-600">
            表示件数: {{ filteredDetailComparisonData3.length }}件
          </span>
        </div>

        <el-table
          :data="filteredDetailComparisonData3"
          border
          stripe
          size="small"
          style="width: 100%"
          max-height="450"
        >
          <!-- 明細No -->
          <el-table-column
            prop="lineNo"
            label="明細No"
            width="80"
            align="center"
            fixed="left"
          >
            <template slot-scope="{ row }">
              {{ row.lineNo }}
            </template>
          </el-table-column>

          <!-- 書類1グループ -->
          <el-table-column :label="doc1Label" align="center">
            <el-table-column
              prop="doc1_goodsShortName"
              label="商品名"
              width="150"
              align="left"
            >
              <template slot-scope="{ row }">
                <span
                  :class="{ 'text-bold text-error': hasDiff(row, '商品名') }"
                  style="white-space: normal; word-break: break-word; display: block;"
                >
                  {{ row.doc1_goodsShortName }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="doc1_goodsRefNo1"
              label="商品番号"
              width="120"
              align="left"
              show-overflow-tooltip
            >
              <template slot-scope="{ row }">
                <span :class="{ 'text-bold text-error': hasDiff(row, '商品番号') }">
                  {{ row.doc1_goodsRefNo1 }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="doc1_quantity1"
              label="数量"
              width="100"
              align="right"
            >
              <template slot-scope="{ row }">
                <span :class="{ 'text-bold text-error': hasDiff(row, '数量', '数量の単位') }">
                  {{ row.doc1_quantity1 }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="doc1_unitPrice"
              label="単価"
              width="100"
              align="right"
            >
              <template slot-scope="{ row }">
                <span :class="{ 'text-bold text-error': hasDiff(row, '単価', '単価の通貨') }">
                  {{ row.doc1_unitPrice }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="doc1_amount"
              label="金額"
              width="120"
              align="right"
            >
              <template slot-scope="{ row }">
                <span :class="{ 'text-bold text-error': hasDiff(row, '金額', '金額の通貨') }">
                  {{ row.doc1_amount }}
                </span>
              </template>
            </el-table-column>
          </el-table-column>

          <!-- 書類2グループ -->
          <el-table-column :label="doc2Label" align="center">
            <el-table-column
              prop="doc2_goodsShortName"
              label="商品名"
              width="150"
              align="left"
            >
              <template slot-scope="{ row }">
                <span
                  :class="{ 'text-bold text-error': hasDiff(row, '商品名') }"
                  style="white-space: normal; word-break: break-word; display: block;"
                >
                  {{ row.doc2_goodsShortName }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="doc2_goodsRefNo1"
              label="商品番号"
              width="120"
              align="left"
              show-overflow-tooltip
            >
              <template slot-scope="{ row }">
                <span :class="{ 'text-bold text-error': hasDiff(row, '商品番号') }">
                  {{ row.doc2_goodsRefNo1 }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="doc2_quantity1"
              label="数量"
              width="100"
              align="right"
            >
              <template slot-scope="{ row }">
                <span :class="{ 'text-bold text-error': hasDiff(row, '数量', '数量の単位') }">
                  {{ row.doc2_quantity1 }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="doc2_unitPrice"
              label="単価"
              width="100"
              align="right"
            >
              <template slot-scope="{ row }">
                <span :class="{ 'text-bold text-error': hasDiff(row, '単価', '単価の通貨') }">
                  {{ row.doc2_unitPrice }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              prop="doc2_amount"
              label="金額"
              width="120"
              align="right"
            >
              <template slot-scope="{ row }">
                <span :class="{ 'text-bold text-error': hasDiff(row, '金額', '金額の通貨') }">
                  {{ row.doc2_amount }}
                </span>
              </template>
            </el-table-column>
          </el-table-column>

          <!-- 判定 -->
          <el-table-column
            prop="judgment"
            label="判定"
            width="80"
            align="center"
          >
            <template slot-scope="{ row }">
              <el-tag
                :type="row.judgment === 'OK' ? 'success' : 'danger'"
                size="small"
              >
                {{ row.judgment }}
              </el-tag>
            </template>
          </el-table-column>

          <!-- 差分 -->
          <el-table-column
            prop="differences"
            label="差分"
            min-width="250"
            align="left"
          >
            <template slot-scope="{ row }">
              <span
                :class="{ 'text-bold text-error': row.differences !== '-', 'text-gray-600': row.differences === '-' }"
                style="white-space: normal; word-break: break-word;"
              >
                {{ row.differences }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
  </div>
</template>

<script>
export default {
  name: 'CrossCheckItemsComparision',
  components: {},
  props: {
    compareData: {
      type: Object,
      default: null,
    },
    selectedDocuments: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      viewMode: 'filtered', // 'filtered' | 'all'
      detailComparisonData3: [], // 比較結果
      keyType: 'goodsShortName', // 'goodsShortName', 'goodsRefNo1', 'both'
      statusFilter: 'match', // 'match', 'doc1Only', 'doc2Only', 'duplicate'
    };
  },
  computed: {
    doc1Label() {
      return this.selectedDocuments[0]?.documentCategory || '書類1';
    },
    doc2Label() {
      return this.selectedDocuments[1]?.documentCategory || '書類2';
    },
    // 書類データ（親から渡されたcompareDataから取得）
    documents() {
      return this.compareData?.documents || [];
    },

    // 書類1の明細データ
    doc1Items() {
      return this.documents[0]?.ocrResults?.aiocrTableItems?.goodsLine || [];
    },

    // 書類2の明細データ
    doc2Items() {
      return this.documents[1]?.ocrResults?.aiocrTableItems?.goodsLine || [];
    },

    // すべての明細項目を行番号で比較（キーなし）
    allItemsComparison() {
      const maxLength = Math.max(this.doc1Items.length, this.doc2Items.length);
      const comparisonResults = [];

      for (let i = 0; i < maxLength; i++) {
        const doc1Item = this.doc1Items[i] || {};
        const doc2Item = this.doc2Items[i] || {};
        const lineNo = i + 1;

        // 各項目の値を取得
        const doc1GoodsShortName = doc1Item.ocrGoodsShortName || '';
        const doc2GoodsShortName = doc2Item.ocrGoodsShortName || '';
        const doc1GoodsRefNo1 = doc1Item.ocrGoodsRefNo1 || '';
        const doc2GoodsRefNo1 = doc2Item.ocrGoodsRefNo1 || '';
        const doc1Quantity = this.formatQuantity(doc1Item);
        const doc2Quantity = this.formatQuantity(doc2Item);
        const doc1UnitPrice = this.formatPrice(doc1Item);
        const doc2UnitPrice = this.formatPrice(doc2Item);
        const doc1Amount = doc1Item.ocrAmountPerItem || '';
        const doc2Amount = doc2Item.ocrAmountPerItem || '';

        // 差分をチェック（calculateDifferences と同じ詳細比較）
        const differences = [];
        if (doc1GoodsShortName !== doc2GoodsShortName) differences.push('商品名');
        if (doc1GoodsRefNo1 !== doc2GoodsRefNo1) differences.push('商品番号');
        // 数量（値）
        if ((doc1Item.ocrQuantity1 || '') !== (doc2Item.ocrQuantity1 || '')) {
          const q1 = parseFloat(doc1Item.ocrQuantity1);
          const q2 = parseFloat(doc2Item.ocrQuantity1);
          if (!isNaN(q1) && !isNaN(q2)) {
            const diff = q2 - q1;
            const sign = diff >= 0 ? '+' : '';
            differences.push(
              `数量（差分：${sign}${diff.toLocaleString()}）`,
            );
          } else {
            differences.push('数量');
          }
        }
        // 数量の単位
        if ((doc1Item.ocrUnit || '') !== (doc2Item.ocrUnit || '')) {
          differences.push('数量の単位');
        }
        // 単価（値）
        if (
          (doc1Item.ocrUnitPrice || '') !==
          (doc2Item.ocrUnitPrice || '')
        ) {
          const p1 = parseFloat(doc1Item.ocrUnitPrice);
          const p2 = parseFloat(doc2Item.ocrUnitPrice);
          if (!isNaN(p1) && !isNaN(p2)) {
            const diff = p2 - p1;
            const sign = diff >= 0 ? '+' : '';
            differences.push(
              `単価（差分：${sign}${diff.toLocaleString()}）`,
            );
          } else {
            differences.push('単価');
          }
        }
        // 単価の通貨
        if (
          (doc1Item.ocrImCustomsCurrencies || '') !==
          (doc2Item.ocrImCustomsCurrencies || '')
        ) {
          differences.push('単価の通貨');
        }
        // 金額（値）
        if (
          (doc1Item.ocrAmountPerItem || '') !==
          (doc2Item.ocrAmountPerItem || '')
        ) {
          differences.push('金額');
        }
        // 金額の通貨
        if (
          (doc1Item.ocrImCustomsCurrencies ||
            doc1Item.ocrCurrency ||
            '') !==
          (doc2Item.ocrImCustomsCurrencies ||
            doc2Item.ocrCurrency ||
            '')
        ) {
          differences.push('金額の通貨');
        }

        // 両方の行が存在しない場合はスキップ
        if (!this.doc1Items[i] && !this.doc2Items[i]) continue;

        const isMatch = differences.length === 0;

        comparisonResults.push({
          id: lineNo,
          lineNo,
          doc1_goodsShortName: this.doc1Items[i] ? doc1GoodsShortName || '( no result )' : '( no result )',
          doc2_goodsShortName: this.doc2Items[i] ? doc2GoodsShortName || '( no result )' : '( no result )',
          doc1_goodsRefNo1: this.doc1Items[i] ? doc1GoodsRefNo1 || '( no result )' : '( no result )',
          doc2_goodsRefNo1: this.doc2Items[i] ? doc2GoodsRefNo1 || '( no result )' : '( no result )',
          doc1_quantity1: this.doc1Items[i] ? doc1Quantity : '( no result )',
          doc2_quantity1: this.doc2Items[i] ? doc2Quantity : '( no result )',
          doc1_unitPrice: this.doc1Items[i] ? doc1UnitPrice : '( no result )',
          doc2_unitPrice: this.doc2Items[i] ? doc2UnitPrice : '( no result )',
          doc1_amount: this.doc1Items[i] ? doc1Amount || '( no result )' : '( no result )',
          doc2_amount: this.doc2Items[i] ? doc2Amount || '( no result )' : '( no result )',
          judgment: isMatch ? 'OK' : 'NG',
          differences: differences.length > 0 ? differences.join(', ') : '-',
          isMatch,
        });
      }

      return comparisonResults;
    },

    // キーのラベル
    keyLabel() {
      const labels = {
        goodsShortName: '商品名',
        goodsRefNo1: '商品番号',
        both: '商品名・商品番号',
      };
      return labels[this.keyType] || '商品名';
    },

    // フィルタリングされたデータ
    filteredDetailComparisonData3() {
      return this.detailComparisonData3.filter((row) => {
        return row.status === this.statusFilter;
      });
    },
  },
  watch: {
    // compareDataが変更されたら比較を再実行
    compareData: {
      handler(newVal) {
        if (newVal && newVal.documents) {
          this.compareDetailItems3();
        }
      },
      deep: true,
    },
  },
  mounted() {
    // compareDataが既にある場合は初期比較を実行
    if (this.compareData && this.compareData.documents) {
      this.compareDetailItems3();
    }
  },
  methods: {
    // 明細項目比較（キーベースマッチング）
    compareDetailItems3() {
      // 書類データを取得（書類1と書類2）
      const doc1 = this.documents[0];
      const doc2 = this.documents[1];

      if (!doc1 || !doc2) {
        console.error('必要な書類データが見つかりません');
        return;
      }

      const doc1GoodsLine = doc1.ocrResults.aiocrTableItems.goodsLine || [];
      const doc2GoodsLine = doc2.ocrResults.aiocrTableItems.goodsLine || [];

      // Step 1: キーでグループ化
      const doc1Groups = this.groupByKey(doc1GoodsLine, this.keyType);
      const doc2Groups = this.groupByKey(doc2GoodsLine, this.keyType);

      // Step 2: 全キーを取得
      const allKeys = new Set([
        ...Object.keys(doc1Groups),
        ...Object.keys(doc2Groups),
      ]);

      const comparisonResults = [];
      let lineNo = 1;

      // Step 3: 各キーについてマッチング
      allKeys.forEach((key) => {
        const doc1Items = doc1Groups[key] || [];
        const doc2Items = doc2Groups[key] || [];

        // Step 4: 状態を判定
        const status = this.determineStatus(doc1Items, doc2Items);

        // Step 5: 結果オブジェクトを作成
        const result = this.createComparisonResult(
          lineNo++,
          key,
          status,
          doc1Items,
          doc2Items,
        );

        comparisonResults.push(result);
      });

      this.detailComparisonData3 = comparisonResults;
      // console.log('明細項目比較結果:', comparisonResults);
    },

    /**
     * キーでグループ化
     */
    groupByKey(lines, keyType) {
      const groups = {};
      lines.forEach((line, index) => {
        let key;
        if (keyType === 'goodsShortName') {
          key = line.ocrGoodsShortName || '';
          // 空の場合は行インデックスで個別化
          if (!key) key = `__empty_name_${index}__`;
        } else if (keyType === 'goodsRefNo1') {
          key = line.ocrGoodsRefNo1 || '';
          // 空の場合は行インデックスで個別化
          if (!key) key = `__empty_refno_${index}__`;
        } else if (keyType === 'both') {
          const name = line.ocrGoodsShortName || '';
          const refNo = line.ocrGoodsRefNo1 || '';
          key = `${name}_${refNo}`;
          // 両方空の場合は行インデックスで個別化
          if (!name && !refNo) key = `__empty_both_${index}__`;
        }

        if (!groups[key]) groups[key] = [];
        groups[key].push(line);
      });
      return groups;
    },

    /**
     * 状態を判定
     */
    determineStatus(doc1Items, doc2Items) {
      const doc1Count = doc1Items.length;
      const doc2Count = doc2Items.length;

      if (doc1Count > 1 || doc2Count > 1) return 'duplicate';
      if (doc1Count === 1 && doc2Count === 1) return 'match';
      if (doc1Count > 0 && doc2Count === 0) return 'doc1Only';
      if (doc1Count === 0 && doc2Count > 0) return 'doc2Only';
    },

    /**
     * 比較結果オブジェクトを作成
     */
    createComparisonResult(lineNo, key, status, doc1Items, doc2Items) {
      const doc1Item = doc1Items[0] || {};
      const doc2Item = doc2Items[0] || {};

      const result = {
        id: lineNo,
        lineNo: lineNo,
        key: key,
        status: status,
      };

      // 各項目の値を設定
      this.setItemValues(result, doc1Item, doc2Item, status);

      // 差分を計算
      this.calculateDifferences(result, status, doc1Item, doc2Item);

      return result;
    },

    /**
     * 項目の値を設定
     */
    setItemValues(result, doc1Item, doc2Item, status) {
      // 商品名
      result.doc1_goodsShortName =
        status !== 'doc2Only'
          ? doc1Item.ocrGoodsShortName || '( no result )'
          : '( no result )';
      result.doc2_goodsShortName =
        status !== 'doc1Only'
          ? doc2Item.ocrGoodsShortName || '( no result )'
          : '( no result )';

      // 商品番号
      result.doc1_goodsRefNo1 =
        status !== 'doc2Only'
          ? doc1Item.ocrGoodsRefNo1 || '( no result )'
          : '( no result )';
      result.doc2_goodsRefNo1 =
        status !== 'doc1Only'
          ? doc2Item.ocrGoodsRefNo1 || '( no result )'
          : '( no result )';

      // 数量（単位付き）
      result.doc1_quantity1 =
        status !== 'doc2Only' ? this.formatQuantity(doc1Item) : '( no result )';
      result.doc2_quantity1 =
        status !== 'doc1Only' ? this.formatQuantity(doc2Item) : '( no result )';

      // 単価（通貨付き）
      result.doc1_unitPrice =
        status !== 'doc2Only' ? this.formatPrice(doc1Item) : '( no result )';
      result.doc2_unitPrice =
        status !== 'doc1Only' ? this.formatPrice(doc2Item) : '( no result )';

      // 金額（通貨付き）
      result.doc1_amount =
        status !== 'doc2Only'
          ? this.formatAmount(doc1Item)
          : '( no result )';
      result.doc2_amount =
        status !== 'doc1Only'
          ? this.formatAmount(doc2Item)
          : '( no result )';
    },

    /**
     * 差分を計算
     */
    calculateDifferences(result, status, doc1Item, doc2Item) {
      if (status === 'match') {
        // 一致の場合、他の項目の差分をチェック
        const differences = [];

        // キーに使われていない項目も比較対象に含める
        if (this.keyType === 'goodsShortName') {
          // 商品名がキーの場合、商品番号も比較
          const refNo1 = doc1Item.ocrGoodsRefNo1 || '';
          const refNo2 = doc2Item.ocrGoodsRefNo1 || '';
          if (refNo1 !== refNo2) {
            differences.push('商品番号');
          }
        } else if (this.keyType === 'goodsRefNo1') {
          // 商品番号がキーの場合、商品名も比較
          const name1 = doc1Item.ocrGoodsShortName || '';
          const name2 = doc2Item.ocrGoodsShortName || '';
          if (name1 !== name2) {
            differences.push('商品名');
          }
        }
        // keyType === 'both' の場合は、商品名と商品番号が既にキーなので追加比較不要

        // 数量（値）
        if (
          (doc1Item.ocrQuantity1 || '') !== (doc2Item.ocrQuantity1 || '')
        ) {
          const q1 = parseFloat(doc1Item.ocrQuantity1);
          const q2 = parseFloat(doc2Item.ocrQuantity1);
          if (!isNaN(q1) && !isNaN(q2)) {
            const diff = q2 - q1;
            const sign = diff >= 0 ? '+' : '';
            differences.push(
              `数量（差分：${sign}${diff.toLocaleString()}）`,
            );
          } else {
            differences.push('数量');
          }
        }
        // 数量の単位
        if ((doc1Item.ocrUnit || '') !== (doc2Item.ocrUnit || '')) {
          differences.push('数量の単位');
        }
        // 単価（値）
        if (
          (doc1Item.ocrUnitPrice || '') !==
          (doc2Item.ocrUnitPrice || '')
        ) {
          const p1 = parseFloat(doc1Item.ocrUnitPrice);
          const p2 = parseFloat(doc2Item.ocrUnitPrice);
          if (!isNaN(p1) && !isNaN(p2)) {
            const diff = p2 - p1;
            const sign = diff >= 0 ? '+' : '';
            differences.push(
              `単価（差分：${sign}${diff.toLocaleString()}）`,
            );
          } else {
            differences.push('単価');
          }
        }
        // 単価の通貨
        if (
          (doc1Item.ocrImCustomsCurrencies || '') !==
          (doc2Item.ocrImCustomsCurrencies || '')
        ) {
          differences.push('単価の通貨');
        }
        // 金額（値）
        if (
          (doc1Item.ocrAmountPerItem || '') !==
          (doc2Item.ocrAmountPerItem || '')
        ) {
          differences.push('金額');
        }
        // 金額の通貨
        if (
          (doc1Item.ocrImCustomsCurrencies ||
            doc1Item.ocrCurrency ||
            '') !==
          (doc2Item.ocrImCustomsCurrencies ||
            doc2Item.ocrCurrency ||
            '')
        ) {
          differences.push('金額の通貨');
        }

        result.diffFields = differences;
        result.differences =
          differences.length > 0 ? differences.join(', ') : '-';
        result.judgment = differences.length === 0 ? 'OK' : 'NG';
      } else if (status === 'doc1Only') {
        result.diffFields = ['all'];
        result.differences = `${this.doc2Label}に対象の${this.keyLabel}なし`;
        result.judgment = 'NG';
      } else if (status === 'doc2Only') {
        result.diffFields = ['all'];
        result.differences = `${this.doc1Label}に対象の${this.keyLabel}なし`;
        result.judgment = 'NG';
      } else if (status === 'duplicate') {
        result.diffFields = ['all'];
        result.differences = '重複（複数一致）';
        result.judgment = 'NG';
      }
    },

    /**
     * 数量フォーマット（単位付き）
     */
    formatQuantity(item) {
      if (!item || !item.ocrQuantity1) return '( no result )';
      const unit = item.ocrUnit || '';
      return `${item.ocrQuantity1}${unit}`;
    },

    /**
     * 単価フォーマット（通貨付き）
     */
    formatPrice(item) {
      if (!item || !item.ocrUnitPrice) return '( no result )';
      const currency = item.ocrImCustomsCurrencies || '';
      return `${item.ocrUnitPrice}${currency}`;
    },

    /**
     * 指定フィールドに差異があるかを判定
     */
    hasDiff(row, ...fields) {
      if (!row.diffFields) return false;
      if (row.diffFields.includes('all')) return true;
      return fields.some((f) =>
        row.diffFields.some(
          (d) => d === f || d.startsWith(f + '（'),
        ),
      );
    },

    /**
     * 金額フォーマット（通貨付き）
     */
    formatAmount(item) {
      if (!item || !item.ocrAmountPerItem) return '( no result )';
      const currency =
        item.ocrImCustomsCurrencies || item.ocrCurrency || '';
      return `${item.ocrAmountPerItem} ${currency}`.trim();
    },

    /**
     * キータイプ変更時にデータを再計算
     */
    handleKeyTypeChange(newKeyType) {
      this.keyType = newKeyType;
      this.compareDetailItems3();
    },

    /**
     * TSVダウンロードボタンクリック時
     */
    handleDownloadTsv() {
      // 表示モードに応じて適切なデータを親に渡す
      const dataToDownload =
        this.viewMode === 'filtered'
          ? this.filteredDetailComparisonData3
          : this.allItemsComparison;
      this.$emit('download-tsv', dataToDownload);
    },
  },
};
</script>

<style lang="scss" scoped>
.view-mode-selection {
  display: flex;
  gap: 8px;
  align-items: center;
}

.text-error {
  color: #f56c6c;
}

.all-items-view {
  margin-bottom: 20px;

  .document-section {
    h4 {
      color: #303133;
      margin-bottom: 12px;
    }
  }
}
</style>
